var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddProfileWithCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28907_187724)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#2999BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8 14.4009C16.3582 14.4009 16 14.759 16 15.2009V16.4009H14.8C14.3582 16.4009 14 16.759 14 17.2009C14 17.6427 14.3582 18.0009 14.8 18.0009H16V19.2009C16 19.6427 16.3582 20.0009 16.8 20.0009C17.2418 20.0009 17.6 19.6427 17.6 19.2009V18.0009H18.8C19.2418 18.0009 19.6 17.6427 19.6 17.2009C19.6 16.759 19.2418 16.4009 18.8 16.4009H17.6V15.2009C17.6 14.759 17.2418 14.4009 16.8 14.4009Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0276 11.3449C13.7242 11.3449 15.0996 9.96953 15.0996 8.27293C15.0996 6.57633 13.7242 5.20093 12.0276 5.20093C10.331 5.20093 8.95557 6.57633 8.95557 8.27293C8.95557 9.96953 10.331 11.3449 12.0276 11.3449Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4139 18.0012C13.2778 17.7659 13.1999 17.4926 13.1999 17.2012C13.1999 16.3175 13.9162 15.6012 14.7999 15.6012H15.1999V15.2012C15.1999 14.4651 15.6969 13.8451 16.3737 13.6586C15.2617 12.5456 13.7249 11.8572 12.0274 11.8572C9.70157 11.8572 7.67761 13.1495 6.63441 15.0552C5.81973 16.5435 7.25725 18.0012 8.95385 18.0012H13.4139Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28907_187724"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddProfileWithCircle);
export default __webpack_public_path__ + "static/media/addProfileWithCircle.082956018e5d4d301a24c7ef00230ab2.svg";
export { ForwardRef as ReactComponent };